import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import SearchIcon from '@material-ui/icons/Search';

import { GetApi, PostApi } from '../../../js_assets/Network';

import LoadingIcon from '../../LoadingIcon'

import { Grid, Button, CircularProgress, Dialog, DialogTitle } from '@material-ui/core';


import AppAdminContainer from '../AppAdminContainer'

import AgGridTable from '../../agGridTable'





const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 8,
        margin: 12

    },
    divider: {
        width: '100%',
    },
    btn_login: {
        color: 'white',
        padding: '2px 2px',
        border: 'none',
        cursor: 'pointer',
        width: '60%',
        opacity: '0.9',
        borderRadius: '3px',
        backgroundColor: '#b1d236',
        fontSize: 14
    },
    ButtonLocation: {
        backgroundColor: '#4CAF50',
        color: 'white',
        '&:hover': {
            background: '#4CAF50'
        }
    },
    ButtonSearch: {
        backgroundColor: '#007bff',
        color: 'white',
        '&:hover': {
            background: '#007bff'
        }
    },
    tab: {
        flexGrow: 1,
        marginTop: 2,
        backgroundColor: '#f7faea'

    },
    iocns: {
        fontSize: 18
    },
    divpadding: {
        width: '60%',
    },


});

class AdminCpStoreWallet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btn_loading_Save: false,
            loading_state_iocn: false,
            loading_state_Table: false,
            success_message_state: false,
            error_message_state: false,
            error_message_text: "",
            success_message_text: "",
            New_List_Code: [],
            columnDefs: [],
            rowData: [],
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
            User_Data: null
        };
    }

    componentDidMount() {





    }





    MakeUUID = (length) => {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    Save_New_Code = (e) => {
        const { Admin_Info } = this.state;
        e.preventDefault();

        this.setState({ btn_loading_Save: true, loading_state_Table: true })

        let New_List_Code_arr = [];



        let Code_Count = this.refs.Code_Count.value

        for (var i = 0; i < Code_Count; i++) {
            let UUID_Value = this.MakeUUID(4) + "-" + this.MakeUUID(4)

            let New_Row = {

                store_Wallet_Offer_Code_Text: UUID_Value.trim(),
                store_Wallet_Offer_Code_Action: this.refs.store_Wallet_Offer_Code_Action.value,
                store_Wallet_Offer_Code_Action_Note: this.refs.store_Wallet_Offer_Code_Action_Note.value,
                store_Wallet_Offer_Code_Action_Details: this.refs.store_Wallet_Offer_Code_Action_Details.value
            }

            New_List_Code_arr.push(New_Row)

        }


        PostApi(`/api/StoreWallet/Add_New_StoreWallet_Codes/${Admin_Info.admin_Id}`, New_List_Code_arr, Admin_Info.jwT_Token_Admin)
            .then(() => {


                this.setState({ btn_loading_Save: false, New_List_Code: New_List_Code_arr })

            })




        this.init_columnDefs(New_List_Code_arr);

    }

    init_columnDefs = (New_List_Code_arr) => {







        let columnDefs = [
            { headerName: "الرمز", field: "store_Wallet_Offer_Code_Text" },
            { headerName: "قيمة الرمز", field: "store_Wallet_Offer_Code_Action" },
            { headerName: "من اجل", field: "store_Wallet_Offer_Code_Action_Note" },
            { headerName: "تفاصيل الاصدار", field: "store_Wallet_Offer_Code_Action_Details" },

        ]




        this.setState({ columnDefs: columnDefs, rowData: New_List_Code_arr, loading_state_Table: false })


    }


    GetrowData = () => {

        const { New_List_Code } = this.state



        return New_List_Code;

    }

    Search_User_By_number = (phone_number) => {

        const { Admin_Info } = this.state;

        if (phone_number.length > 0) {

            this.setState({ loading_state_iocn: true })
            let UserModel = {
                user_Phone: phone_number
            }


            PostApi(`/api/admin/Get_User_by_PhoneNmber/${Admin_Info.admin_Id}`, UserModel, Admin_Info.jwT_Token_Admin)
                .then((rep) => {

                    if (rep !== false) {


                        this.setState({ User_Data: rep })
                    } else {

                        alert("رقم غير موجود");

                    }


                    this.setState({ loading_state_iocn: false })
                })

        }

    }

    Search_User_By_number = (phone_number) => {

        const { Admin_Info } = this.state;

        if (phone_number.length > 0) {

            this.setState({ loading_state_iocn: true })
            let UserModel = {
                user_Phone: phone_number
            }


            PostApi(`/api/admin/Get_User_by_PhoneNmber/${Admin_Info.admin_Id}`, UserModel, Admin_Info.jwT_Token_Admin)
                .then((rep) => {

                    if (rep !== false) {


                        this.setState({ User_Data: rep })
                    } else {


                        this.setState({ loading_state_iocn: false, error_message_state: true, error_message_text: "رقم غير موجود" })

                    }


                    this.setState({ loading_state_iocn: false })
                })

        }

    }

    Add_New_Amount_StoreWallet = (amount) => {

        const { User_Data, Admin_Info } = this.state;

        if (amount.length !== 0 && amount.length <= 3) {

            this.setState({ loading_state_iocn: true })

            let Recharge_model = {
                store_Wallet_Transaction_Type: "IN",
                store_Wallet_Transaction_Amount: parseFloat(amount),
                code_Offer_Transaction: "-",
                store_Wallet_Transaction_Action: ` ايداع من تطبيق  بروتين : ${amount}`
            }


            PostApi(`/api/StoreWallet/Recharge_Store_Wallet_User_By_Admin/${User_Data.userId}/${Admin_Info.admin_Id}`, Recharge_model, Admin_Info.jwT_Token_Admin)
                .then(() => {


                    let message = `تم شحن  الرصيد `
                    this.setState({ loading_state_iocn: false, success_message_state: true, success_message_text: message })




                })

        } else {

            this.setState({ loading_state_iocn: false, error_message_state: true, error_message_text: "الرقم اكبر من الف او غير صحيح" })
        }



    }

    render() {
        const { classes } = this.props;
        const { btn_loading_Save, loading_state_Table, New_List_Code, columnDefs, User_Data, loading_state_iocn } = this.state;



        return (

            <AppAdminContainer Title={"لوحة رصيد المتاجر"} >
                {loading_state_iocn ? <LoadingIcon /> : null}

                <Grid justify="center" style={{ paddingTop: "20px", paddingBottom: "56px" }} alignItems="center" container spacing={8}  >

                    <Grid justify="center" alignItems="center" container spacing={8}  >
                        <h3 className="containerOfferh4" >    شحن رصيد العميل   </h3>
                    </Grid>

                    <div >
                        <br />
                        <Grid item xs   >
                            <div >

                                <input
                                    placeholder=" رقم جوال العميل" name="phone_number"
                                    ref="phone_number"
                                    maxLength="10"
                                    minLength="10"
                                    required
                                />
                            </div>
                        </Grid>


                        <Grid justify="center" alignItems="center" container spacing={8}  >


                            <button onClick={() => this.Search_User_By_number(this.refs.phone_number.value)} size="small" variant="contained" className={classes.ButtonSearch}    >
                                <SearchIcon />
                            </button>



                        </Grid>

                        {
                            User_Data !== null ?

                                <div>
                                    <br />
                                    <label>الاسم : {User_Data.userName}</label><br />
                                    <label>رقم الجوال  :{User_Data.user_Phone}</label><br /><br />
                                    <div >
                                        <input
                                            placeholder="ادخل المبلغ للشحن الرصيد"
                                            name="store_Wallet_amount"
                                            ref="store_Wallet_amount"
                                            type="number"
                                            maxLength="3"
                                            minLength="3"
                                        />
                                    </div>

                                    <br />
                                    <Grid justify="center" alignItems="center" container spacing={8}  >
                                        <button onClick={() => this.Add_New_Amount_StoreWallet(this.refs.store_Wallet_amount.value)} size="small" variant="contained" className={classes.ButtonSearch}    >
                                            <label>   اشحن الرصيد </label>
                                        </button>
                                    </Grid>
                                </div>
                                :
                                null

                        }
                    </div>


                </Grid>





                <Grid justify="center" style={{ paddingTop: "100px" }} alignItems="center" container spacing={8}  >

                    <form onSubmit={this.Save_New_Code} acceptCharset={"multipart/form-data"}>

                        <h3 className="containerOfferh4" >  اصدار كود جديد   </h3>

                        عدد الاكواد
                        <div >

                            <input placeholder="عدد الاكواد" name="Code_Count" ref="Code_Count" type="number" required />
                        </div>
                        قيمة الكود
                        <div >
                            <input placeholder="   قيمة الكود " name="store_Wallet_Offer_Code_Action" ref="store_Wallet_Offer_Code_Action" required />
                        </div>
                        تم اصدر الكود لمن ؟؟
                        <div >
                            <input placeholder="اكتب رقم الجوال او الايميل للجهة او حساب التواصل للمشهور" name="store_Wallet_Offer_Code_Action_Note" ref="store_Wallet_Offer_Code_Action_Note" required />
                        </div>
                        اكتب سبب اصدرا الكود
                        <div >
                            <input placeholder=" اذكر لماذا اصدرت هذا الكود و لمن" name="store_Wallet_Offer_Code_Action_Details" ref="store_Wallet_Offer_Code_Action_Details" required />
                        </div>



                        <Grid justify="center" alignItems="center" container spacing={8}  >

                            <button disabled={btn_loading_Save} variant="contained" type="Submit" color="primary" className={classes.btn_login}  >
                                {btn_loading_Save === true ? <label> <CircularProgress color={"secondary"} /> يتم تصدير الاكواد  </label> : <label>تصدير</label>}

                            </button>
                        </Grid>



                    </form>
                </Grid>


                <br></br>

                {New_List_Code.length !== 0 ?
                    <Grid justify="center" alignItems="center" container spacing={8}  >
                        <AgGridTable loading_state_Table={loading_state_Table} columnDefs={columnDefs} rowData={this.GetrowData()} />
                    </Grid>

                    :
                    null
                }







                <Dialog
                    open={this.state.success_message_state}
                    onClose={() => this.setState({ success_message_state: false })}
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="alertIcon">✔️ <label>  {this.state.success_message_text}</label> </div>
                    </DialogTitle>


                </Dialog>

                <Dialog
                    open={this.state.error_message_state}
                    onClose={() => this.setState({ error_message_state: false })}
                >
                    <DialogTitle >
                        <div className="alertIconerror"> ⛔️ <span> {this.state.error_message_text}  </span>
                            <hr></hr>

                            <span>{this.state.failed_message}</span>
                        </div>
                    </DialogTitle>


                </Dialog>



            </AppAdminContainer >




        )
    }


}

AdminCpStoreWallet.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminCpStoreWallet);